import React from "react";
import { Box, CssBaseline, AppBar, Toolbar, Typography, Drawer, List, ListItem, ListItemButton, ListItemText, IconButton, } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, Outlet, Route, Routes, useLocation } from "react-router-dom";
import Dashboard from "../components/AdminPanel/Dashboard.js";
import Users from "../components/AdminPanel/UserManagement.js";
import Professionals from "../components/AdminPanel/ProfessionalManagement.js";
import Categories from "../components/AdminPanel/CategoryManagement.js";
import Companies from "../components/AdminPanel/CompanyManagement.js";
import Resumes from "../components/AdminPanel/ResumeManagement.js";
import Content from "../components/AdminPanel/ContentManagement.js";
import Reviews from "../components/AdminPanel/ReviewManagement.js";
import Metrics from "../components/AdminPanel/Metrics.js";

const drawerWidth = 240;

const AdminPanel = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { text: "Dashboard", path: "/admin/dashboard" },
    { text: "Usuarios", path: "/admin/users" },
    { text: "Profesionales", path: "/admin/professionals" },
    { text: "Categorías", path: "/admin/categories" },
    { text: "Empresas", path: "/admin/companies" },
    { text: "Currículums", path: "/admin/resumes" },
    { text: "Contenido", path: "/admin/content" },
    { text: "Reseñas", path: "/admin/reviews" },
    { text: "Métricas", path: "/admin/metrics" },
  ];

  const drawer = (
    <div>
      <Toolbar />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
            >
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: "#3f51b5",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Panel de Administración
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        {/* Drawer para pantallas pequeñas */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Mejora el rendimiento en dispositivos móviles
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        {/* Drawer permanente para pantallas grandes */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        {/* Configuración de rutas hijas aquí */}
        <Routes>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="professionals" element={<Professionals />} />
          <Route path="categories" element={<Categories />} />
          <Route path="companies" element={<Companies />} />
          <Route path="resumes" element={<Resumes />} />
          <Route path="content" element={<Content />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="metrics" element={<Metrics />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default AdminPanel;
